export default __webpack_public_path__ + "static/media/Book9.411d5d8c.pdf";